import { IChartData, IDashboardDimensionsViewModel, Filters } from "../plotdata";

//Actions / requests
export enum WorkerRequestType { Ping, Fetch, ChartData, FetchSurvival }
export interface IWorkerFetchRequest { all: boolean, rawRefs: any, rawRows: string}
export interface IWorkerFetchSurvivalRequest { all: boolean,  rawSurvivalRows: string, rawKMSurvivalRows: string, activeFilters: Filters}
export interface IWorkerChartDataRequest { filtersToApply: Filters };
export interface IWorkerRequest {
    type: WorkerRequestType;
    id: string;
    payload?: any; //?
}

//Results
export enum WorkerResultType { Ping, Fetch, ChartData, InvalidType }
export interface IWorkerResult {
    type: WorkerResultType;
    id: string;
    payload?: any; //?
}
export interface IWorkerPingResult {}
export interface IWorkerFetchResult { allData: boolean, references: IDashboardDimensionsViewModel, chartData: IChartData }
export type IWorkerChartDataResult = IChartData;